"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const awsui_components_react_1 = require("@amzn/awsui-components-react");
const awsui_collection_hooks_1 = require("@amzn/awsui-collection-hooks");
const react_arb_tools_1 = require("@amzn/react-arb-tools");
const CONSTANTS = __importStar(require("../../../common/constants"));
const provision_status_indicator_1 = require("../../common/provision_status_indicator");
function ExecutionSteps(props) {
    const [troubleshootStep, setTroubleshootStep] = react_1.default.useState(undefined);
    let steps = props.executionSteps;
    if (props.provisionStatus === 'Execution_Succeed') {
        steps = steps.filter((e) => e.status !== 'Pending');
    }
    const { items, actions, filteredItemsCount, collectionProps, filterProps, paginationProps } = (0, awsui_collection_hooks_1.useCollection)(steps, {
        filtering: {},
        pagination: { pageSize: 10 },
        sorting: {},
        selection: {},
    });
    const [localeBundle] = (0, react_arb_tools_1.useBundle)(CONSTANTS.STRINGS_NAMESPACE);
    const onExecutionStepClick = (executionStep) => (e) => {
        e.preventDefault();
        setTroubleshootStep(executionStep);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(TroubleshootModal, { close: () => setTroubleshootStep(undefined), executionStep: troubleshootStep }), (0, jsx_runtime_1.jsx)(awsui_components_react_1.Table, { loadingText: localeBundle === undefined
                    ? 'Loading execution steps'
                    : localeBundle.getMessage('loading-execution-steps'), items: items, columnDefinitions: [
                    {
                        id: 'step name',
                        header: 'Step',
                        cell: (e) => {
                            if (e.status === 'Failed' || e.status === 'TimedOut') {
                                return (0, jsx_runtime_1.jsx)(awsui_components_react_1.Link, { onFollow: onExecutionStepClick(e), children: e.name });
                            }
                            else {
                                return e.name;
                            }
                        },
                    },
                    {
                        id: 'action',
                        header: 'Action',
                        cell: (e) => e.action,
                    },
                    {
                        id: 'step status',
                        header: 'Status',
                        cell: (e) => (0, jsx_runtime_1.jsx)(provision_status_indicator_1.ProvisionStepStatusIndicator, { provisionStepStatus: e.status }),
                    },
                ], sortingDisabled: true, empty: (0, jsx_runtime_1.jsx)(awsui_components_react_1.Box, { textAlign: "center", color: "inherit", children: (0, jsx_runtime_1.jsx)(awsui_components_react_1.Box, { padding: { bottom: 's' }, variant: "p", color: "inherit", children: localeBundle === undefined
                            ? 'No execution step to display.'
                            : localeBundle.getMessage('no-execution-step-display') }) }), pagination: (0, jsx_runtime_1.jsx)(awsui_components_react_1.Pagination, { ...paginationProps, ariaLabels: {
                        nextPageLabel: 'Next page',
                        previousPageLabel: 'Previous page',
                        pageLabel: (pageNumber) => `${pageNumber}`,
                    } }) })] }));
}
exports.default = ExecutionSteps;
const TroubleshootModal = (props) => {
    return ((0, jsx_runtime_1.jsx)(awsui_components_react_1.Modal, { onDismiss: props.close, visible: props.executionStep !== undefined, closeAriaLabel: "Close modal", footer: (0, jsx_runtime_1.jsx)(awsui_components_react_1.Box, { float: "right", children: (0, jsx_runtime_1.jsx)(awsui_components_react_1.SpaceBetween, { direction: "horizontal", size: "xs", children: (0, jsx_runtime_1.jsx)(awsui_components_react_1.Button, { onClick: props.close, variant: "link", children: "Close" }) }) }), header: "Troubleshoot", children: props.executionStep !== undefined && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Provision is failed at step ", (0, jsx_runtime_1.jsx)("b", { children: props.executionStep.name }), ".", ' '] }), props.executionStep.name.startsWith('EDM_') ? ((0, jsx_runtime_1.jsxs)("p", { children: ["It is a step owned by EDM. Please refer", ' ', (0, jsx_runtime_1.jsx)(awsui_components_react_1.Link, { external: true, href: CONSTANTS.TROUBLESHOOT_WIKI_LINK, children: "Troubleshoot Wiki" }), ' ', "for help."] })) : ((0, jsx_runtime_1.jsx)("p", { children: " It is a client-owned step. Please reach out to process owner for help." })), (props.executionStep.action === 'aws:executeAutomation' && ((0, jsx_runtime_1.jsxs)("p", { children: ["Failed Automation ID: ", (0, jsx_runtime_1.jsx)("b", { children: props.executionStep.outputs['ExecutionId'][0] })] }))) ||
                    (props.executionStep.action === 'aws:runCommand' && ((0, jsx_runtime_1.jsxs)("p", { children: ["Failed Command ID: ", (0, jsx_runtime_1.jsx)("b", { children: props.executionStep.outputs['CommandId'][0] })] }))) || (0, jsx_runtime_1.jsx)("span", {})] })) }));
};
